"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const enums_1 = require("./enums");
const errorResponse = (res, error) => {
    let status = Number(lodash_1.default.get(error, 'status', 400));
    let errorResponsePayload = {
        data: undefined,
        key: enums_1.BaseErrorKey.unknownError,
        message: 'Unknown error',
        status,
    };
    const knownErrors = {
        SyntaxError: {
            key: enums_1.BaseErrorKey.syntaxError,
            message: error.message,
            status: 400,
        },
    };
    const { message, } = error;
    const key = (lodash_1.default.get(error, 'key') || enums_1.BaseErrorKey.unknownError);
    errorResponsePayload.message = message;
    errorResponsePayload.key = key;
    const knownError = lodash_1.default.get(knownErrors, error.name);
    if (knownError) {
        errorResponsePayload = knownError;
    }
    if (lodash_1.default.includes([
        enums_1.BaseErrorKey.syntaxError,
        enums_1.BaseErrorKey.requestValidationError,
    ], key)) {
        const data = lodash_1.default.get(error, 'data');
        errorResponsePayload.data = data;
    }
    status = errorResponsePayload.status;
    const output = lodash_1.default.pick(errorResponsePayload, ['message', 'key', 'data']);
    return res.status(status).json(output);
};
exports.default = errorResponse;
